/*                                                                      */
/*                                                */
/*                                                     */
import { active_reaction, untrack } from './internal/client/runtime.js';
import { is_array } from './internal/shared/utils.js';
import { user_effect } from './internal/client/index.js';
import * as e from './internal/client/errors.js';
import { legacy_mode_flag } from './internal/flags/index.js';
import { component_context } from './internal/client/context.js';
import { DEV } from 'esm-env';

if (DEV) {
	/**
 *
 */
	function throw_rune_error(rune) {
		if (!(rune in globalThis)) {
			/*                                                                                                         */
			/*              */
			let value; /*                                                          */
			Object.defineProperty(globalThis, rune, {
				configurable: true,
				/*                                     */
				get: () => {
					if (value !== undefined) {
						return value;
					}

					e.rune_outside_svelte(rune);
				},
				set: (v) => {
					value = v;
				}
			});
		}
	}

	throw_rune_error('$state');
	throw_rune_error('$effect');
	throw_rune_error('$derived');
	throw_rune_error('$inspect');
	throw_rune_error('$props');
	throw_rune_error('$bindable');
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getAbortSignal() {
	if (active_reaction === null) {
		e.get_abort_signal_outside_reaction();
	}

	return (active_reaction.ac ??= new AbortController()).signal;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function onMount(fn) {
	if (component_context === null) {
		e.lifecycle_outside_component('onMount');
	}

	if (legacy_mode_flag && component_context.l !== null) {
		init_update_callbacks(component_context).m.push(fn);
	} else {
		user_effect(() => {
			const cleanup = untrack(fn);
			if (typeof cleanup === 'function') return /*                     */ (cleanup);
		});
	}
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function onDestroy(fn) {
	if (component_context === null) {
		e.lifecycle_outside_component('onDestroy');
	}

	onMount(() => () => untrack(fn));
}

/**
 *
 *
 *
 *
 *
 */
function create_custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
	return new CustomEvent(type, { detail, bubbles, cancelable });
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function createEventDispatcher() {
	const active_component_context = component_context;
	if (active_component_context === null) {
		e.lifecycle_outside_component('createEventDispatcher');
	}

	/**
 *
 *
 */
	return (type, detail, options) => {
		const events = /*                                                */ (
			active_component_context.s.$$events
		)?.[/*                 */ (type)];

		if (events) {
			const callbacks = is_array(events) ? events.slice() : [events];
			/*                                                         */
			/*                                 */
			const event = create_custom_event(/*                 */ (type), detail, options);
			for (const fn of callbacks) {
				fn.call(active_component_context.x, event);
			}
			return !event.defaultPrevented;
		}

		return true;
	};
}

/*                                                               */

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function beforeUpdate(fn) {
	if (component_context === null) {
		e.lifecycle_outside_component('beforeUpdate');
	}

	if (component_context.l === null) {
		e.lifecycle_legacy_only('beforeUpdate');
	}

	init_update_callbacks(component_context).b.push(fn);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function afterUpdate(fn) {
	if (component_context === null) {
		e.lifecycle_outside_component('afterUpdate');
	}

	if (component_context.l === null) {
		e.lifecycle_legacy_only('afterUpdate');
	}

	init_update_callbacks(component_context).a.push(fn);
}

/**
 *
 *
 */
function init_update_callbacks(context) {
	var l = /*                                 */ (context).l;
	return (l.u ??= { a: [], b: [], m: [] });
}

export { flushSync } from './internal/client/reactivity/batch.js';
export {
	createContext,
	getContext,
	getAllContexts,
	hasContext,
	setContext
} from './internal/client/context.js';
export { hydrate, mount, unmount } from './internal/client/render.js';
export { tick, untrack, settled } from './internal/client/runtime.js';
export { createRawSnippet } from './internal/client/dom/blocks/snippet.js';
